import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

import { ZonarUiIconModule } from '@zonar-ui/icon';
import { ZonarUiLozengeModule } from '@zonar-ui/lozenge';

import { AssetIoBadgeComponent } from './components/asset-io-badge/asset-io-badge.component';
import { AssetIoDetailsComponent } from './components/asset-io-details/asset-io-details.component';

import { AssetIoService } from './asset-io.service';
import { ZonarUiI18nModule } from '@zonar-ui/i18n';

@NgModule({
  declarations: [AssetIoBadgeComponent, AssetIoDetailsComponent],
  imports: [CommonModule, FlexLayoutModule, ZonarUiIconModule, ZonarUiLozengeModule, ZonarUiI18nModule],
  exports: [AssetIoBadgeComponent, AssetIoDetailsComponent],
  providers: [AssetIoService]
})
export class AssetIoModule {}
